import useSignaturePad from "../../customHooks/useSignaturePad";
import {
  MAX_FILE_UPLOAD_SIZE_FIGURE,
  MAX_FILE_UPLOAD_SIZE_TEXT,
} from "../../utils/constants";
import { convertFileToBase64 } from "../../utils/helpers";
import { errorToast } from "../../utils/makeToast";

interface SignaturePadProps {
  onClickSave: (url: string, fileName: string, fileType: string, objectUrl:string) => void;
}
const SignaturePad: React.FC<Partial<SignaturePadProps>> = ({
  onClickSave,
}) => {
  const { canvasRef, clearCanvas, signatureFile } = useSignaturePad();

  const returnImageUrl = async () => {
    if (signatureFile) {
      const fileSizeInKb = signatureFile.size / 1000;
      if (fileSizeInKb > MAX_FILE_UPLOAD_SIZE_FIGURE) {
        return errorToast(
          `File size exceeds ${MAX_FILE_UPLOAD_SIZE_TEXT.toUpperCase()}. Please upload a smaller file.`
        );
      }
      const url = await convertFileToBase64(signatureFile);
      const objectUrlStr = URL.createObjectURL(signatureFile)
      onClickSave &&
        url &&
        onClickSave(url, signatureFile.name, signatureFile.type, objectUrlStr);
    } else return errorToast("Please draw your signature to proceed");
  };
  return (
    <div className="flex flex-col items-center gap-4">
      <canvas
        ref={canvasRef}
        className="border border-gray-500 bg-body-secondary"
      />
      <div className="d-flex gap-3 align-items-center justify-content-center w-100">
        <button
          type="button"
          onClick={clearCanvas}
          className="p-2 bg-danger text-white rounded"
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn p-2 bg-warning text-white rounded"
          onClick={returnImageUrl}
          disabled={!signatureFile}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default SignaturePad;
